module.exports = __webpack_public_path__ + "static/img/adidas.9a7d950.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adidas.png
// module id = X9jv
// module chunks = 1